import React from 'react'

const SpacerBlock = () => {
  return <div style={{ margin: '32px 0' }} />
}

export default SpacerBlock
